var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-file-input',{attrs:{"placeholder":_vm.placeholder,"label":_vm.label,"accept":_vm.accept,"small-chips":_vm.small_chips,"show-size":_vm.show_size,"dense":_vm.dense,"prepend-icon":_vm.prepend_icon,"multiple":_vm.multiple,"counter":_vm.counter,"outlined":_vm.outlined}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }